import { normalize, schema } from 'normalizr';
import { createXhrStatusModule, xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { fetchedHourSummary, fetchedProjectSummary, type State } from './hourSummary.types';

const hourSummaryXhrStatusModule = createXhrStatusModule('hourSummary');

const hourSummarySchema = new schema.Entity('hourSummary');
const hourSummaryListSchema = new schema.Array(hourSummarySchema);

const initialState: State = {
  entities: {},
  result: [],
  maybeHasMore: false,
  totalCount: 0,
  xhrStatus: xhrStatusFactory(),
  projectSummaries: {},
};

const reducer = reducerWithInitialState(initialState)
  .case(fetchedHourSummary, (state, payload) => {
    const normalized = normalize(payload.data, hourSummaryListSchema);
    const entities = payload.append
      ? { ...state.entities, ...normalized.entities.hourSummary }
      : normalized.entities.hourSummary || {};
    const result = payload.append ? [...state.result, ...normalized.result] : normalized.result;

    return {
      ...state,
      entities,
      result,
      maybeHasMore: payload.maybeHasMore,
      totalCount: payload.totalCount,
    };
  })
  .case(fetchedProjectSummary, (state, payload) => {
    const normalized = normalize(payload.data, hourSummaryListSchema);
    return {
      ...state,
      projectSummaries: {
        ...state.projectSummaries,
        [payload.clientId]: {
          entities: normalized.entities.hourSummary || {},
          result: normalized.result,
        },
      },
    };
  });

export default hourSummaryXhrStatusModule.withXhrStatusReducer(reducer);
